export enum ProcessFlow {
  order = 0,
  result,
  invoice,
  action
}
